<template>
  <button
    :class="['rounded-full font-medium', paddingX, paddingY]"
    @click="(e) => $emit('click', e)"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    px: {
      default: true,
      type: Boolean,
    },
    smaller: Boolean,
    disabled: Boolean,
  },
  computed: {
    // checks for the correct padding
    paddingX() {
      if (this.px) return this.smaller ? "px-4" : "px-10";

      return null;
    },
    paddingY() {
      if (this.smaller) return "py-1";

      return "py-3";
    },
  },
};
</script>

<style></style>
